import {
  AuthApi,
  Configuration,
  ReviewSessionsApi,
  UsersApi,
  WordsApi,
} from "../generated";

const readApiBaseFromEnv = (): string => {
  if (
    process.env.NODE_ENV === "production" &&
    !document.location.host.startsWith("localhost")
  ) {
    return `https://${document.location.host}`;
  } else if (process.env.REACT_APP_API_BASE) {
    return process.env.REACT_APP_API_BASE;
  }
  return "http://localhost:8000";
};

// prettier-ignore
export const basePath = readApiBaseFromEnv();

const readAccessToken = async (): Promise<string> => {
  return localStorage.getItem("token") || "";
};

const apiConfig: Configuration = new Configuration({
  basePath,
  accessToken: readAccessToken,
});

export const authApi: AuthApi = new AuthApi(apiConfig);
export const userApi: UsersApi = new UsersApi(apiConfig);
export const reviewSessionsApi: ReviewSessionsApi = new ReviewSessionsApi(
  apiConfig
);
export const wordsApi: WordsApi = new WordsApi(apiConfig);
